import React, { useEffect, useState } from "react";
import { google, loginlbg, logo } from "../assets/Images";
import Profile from "../components/login/Profile";
import LoadingSpinnerComponent from '../components/LoadingSpinner'
import PageTitle from "../components/PageTitle";
import {
  LiaAngleDownSolid,
  LiaAngleLeftSolid,
  LiaAngleUpSolid,
} from "react-icons/lia";
import FormBox from "../components/FormBox";
import { useGoogleLogin } from "@react-oauth/google";
import { GetOtp, VerifyOtp } from "../services/Helpers/AxiosConfiguration";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Api from "../api/api";
import { useMyContext } from '../context/MyContext';

const Login = () => {
  const { loading, startLoading, stopLoading, setTCData, setTCVersionId } = useMyContext();
  const navigate = useNavigate();
  const [phoneNumber, setphoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [otpModal, setotpModal] = useState(false);
  
  // Check if user has logged in before
  const isReturningUser = () => {
    const hasUserDetails = localStorage.getItem("user_details");
    const hasLogin = localStorage.getItem("login");
    const hasAccessToken = localStorage.getItem("access_token");
    return !!(hasUserDetails || hasLogin === "true" || hasAccessToken);
  };
  
  const [isReturning, setIsReturning] = useState(false);
  
  useEffect(() => {
    setIsReturning(isReturningUser());
  }, []);

  function getotpApi(value) {
    startLoading();
    GetOtp({ phoneNumber: value })
      .then((res) => {
        setIsValid(true);
        setotpModal(true);
        stopLoading();
      })
      .catch((err) => {
        stopLoading();
      });
  }

  const getOtp = () => {
    if (phoneNumber) {
      getotpApi();
    } else {
      setIsValid(false);
    }
  };

  function VerifyOtpApi() {
    startLoading();
    const Payload = {
      phoneNumber,
      OTP: otp,
    };
    VerifyOtp(Payload)
      .then((res) => {
        setIsValid(true);
        localStorage.setItem("user_details", JSON.stringify(res.data.data[0]));
        localStorage.setItem("access_token", res.data.data[0].access_token);
        localStorage.setItem("refresh_token", res.data.data[0].refresh_token);
        localStorage.setItem("login", true);
        setotpModal(true);
        stopLoading();
        navigate("/dashboard");
      })
      .catch((err) => {
        stopLoading();
      });
    setotpModal(false);
  }

  const formik = useFormik({
    initialValues: {
      phoneNumber: "",
      otp: "",
    },
    validationSchema: Yup.object({
      /*phoneNumber: Yup.string()
        .matches(
          /^[6-9]{1}[0-9]{9}$/,
          "Phone number must start with 6,7, 8, or 9 and be 10 digits long"
        )
        .required("Phone number is required"),*/
    }),
    onSubmit: (values) => {
      setotpModal(true);
      setphoneNumber(values.phoneNumber);
      getotpApi(values.phoneNumber);
    },
  });

  async function Login(data) {
    try {
      startLoading();
      let res = await Api.LoginApi(data);
      localStorage.setItem("user_details", JSON.stringify(res.data));
      localStorage.setItem("access_token", res.data.access_token);
      localStorage.setItem("refresh_token", res.data.refresh_token);
      stopLoading();
      localStorage.setItem("TCVersionId", res.data.version_id)
      localStorage.setItem("TCAccepted", res.data.terms_accepted)
      localStorage.setItem("TCData", res.data.tc_content)
      navigate("/dashboard");
    } catch (error) {
      stopLoading();
      alert("Unable to login, try later!");
    }
  }
  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    onSuccess: async (codeResponse) => {
      let Payload = {
        code: codeResponse.code,
      };
      Login(Payload);
    },
    onError: () => console.log("Login Failed"),
  });

  return (
    <>
      {loading && <LoadingSpinnerComponent />}
      <PageTitle title="Login" />
      <div className="login-wrapper login w-100 vh-100 d-md-flex align-content-center px-4 px-md-auto">
        <div className="login-right d-flex align-items-center justify-content-center w-sm-100 pt-0 pt-md-5 mx-auto">
          <div className="login-wrap mx-auto w-100">
            <div className="logo text-center">
              <img src={logo} className="mx-auto" alt="" style={{
                height: "75px",
                width: "auto",
                maxWidth: "100%",
                objectFit: "contain"
              }} />
            </div>
            <div className="login-wrap-content">
              <div className="mb-3 pb-md-1">
                <h2 className="fw-semibold mb-1">
                  {isReturning ? "Welcome Back" : "Welcome to FlowTickr"}
                </h2>
                <p className="fs-14 fw-semibold">
                  {isReturning ? "Sign In" : "Get Started"}
                </p>
              </div>
              {/*<div className="mb-1 pb-md-1">
                {/* <PhoneInput  /> 
                <div className="mb-3">
                  <div className="d-flex gap-2">
                    <div className="d-flex flex-column gap-2 w-100">
                      <input
                        type="text"
                        id="phone"
                        className={`form-control ${formik.touched.phoneNumber &&
                          formik.errors.phoneNumber
                          ? "is-invalid"
                          : ""
                          }`}
                        value={formik.values.phoneNumber}
                        placeholder="Enter Your Phone Number"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="phoneNumber"
                        pattern="[7-9]{1}[0-9]{9}"
                        title="Phone number must start with 7, 8, or 9 and be 10 digits long"
                      />
                      {formik.touched.phoneNumber &&
                        formik.errors.phoneNumber && (
                          <div className="invalid-feedback">
                            {formik.errors.phoneNumber}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <button
                  onClick={formik.handleSubmit}
                  className="btn bg-primary text-heading w-100 fs-6"
                >
                  Get Otp
                </button>
              </div>*/}
              <div className="login-or mt-3 pt-1 pt-md-2">
                {/*<div className="d-flex align-items-center justify-content-center gap-2 mb-3 pb-1 pb-md-2">
                  <span className="d-block login-or-line"></span>
                  <span className="text-uppercase">or</span>
                  <span className="d-block login-or-line"></span>
                </div>*/}
                <button
                  className="btn fs-6 gap-2 bg-transparent d-flex w-100 align-items-center justify-content-center"
                  onClick={googleLogin}
                >
                  <img src={google} alt="" />
                  Continue with google
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {otpModal && (
        <div
          className={`login-otp align-items-center justify-content-center p-3 position-fixed top-0 start-0 w-100 z-2 bg-black bg-opacity-20 h-100 ${otpModal ? "d-flex" : "d-none"
            }`}
        >
          <div className="login-otp-wrap bg-white p-3 p-md-4 rounded-4">
            <div className="login-popup-header d-flex align-items-center gap-2 mb-3 pb-md-1">
              <button
                className="login-close text-body d-flex align-items-center justify-content-center rounded-pill border-0 p-0"
                onClick={() => {
                  setotpModal(false);
                }}
              >
                <LiaAngleLeftSolid />
              </button>
              <h4 className="mb-0">User Validation </h4>
            </div>
            <FormBox
              className="mb-3"
              type="number"
              label="Enter the code what we have send in your Phone Number"
              placeholder="Type here"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <button
              onClick={VerifyOtpApi}
              className="btn bg-primary w-100 fs-14"
            >
              Verify code
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Login;
